<template>
  <div v-if="isLoaded">
    <div class="wraper">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <div class="row myrow">
          <div class="col-xs-12 mycol header-title">
            <div class="col-xs-12 mycol">
              <div class="h-t-name pull-left">
                Мониторинг Лизинговых компаний
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid mycontainer-fluid content content_table">
        <div class="wrapper-header">
          <form>
            <div class="row myrow project-filter filter-wrapper-stl">
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="UF_NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :multiple="false"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filterForm.UF_COMPANY_ID"
                  :options="getListOrgsLizing"
                  :searchable="true"
                  placeholder
                  :disabled="!!monitoringLizingOrgs.IS_BLOCK_ORG_SELECT"
                >
                  <span slot="noOptions">Организации не найдены</span>
                  <span slot="noResult">Организации не найдены</span>
                </Multiselect>
              </div>
              <div
                v-if="monitoringLizingOrgs.PHILTER_LIST"
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="YEAR"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :loading="!listRendered"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="YEAR"
                  v-model="filterForm.UF_YEAR"
                  :options="monitoringLizingOrgs.PHILTER_LIST"
                  :multiple="false"
                  placeholder
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  :loading="!listRendered"
                  :limit="1"
                  :limitText="filterItemText"
                  track-by="ID"
                  v-model="filterForm.UF_TYPE_PERIOD_REPORTING_ID"
                  :options="filterKvartal"
                  :multiple="false"
                  placeholder
                >
                  <span slot="noOptions"
                    >Выберите год для формирования списка отчетных
                    периодов</span
                  >
                  <span slot="noResult"
                    >Выберите год для формирования списка отчетных
                    периодов</span
                  >
                </Multiselect>
              </div>
              <div class="stl-df-ac" style="width: 394px;">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                    @click="clearFilter"
                    type="button"
                  >
                    Сброс
                  </button>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    class="project-filter__butt-btn butt-new-style stl-w-full"
                    type="button"
                    @click="applyFilter"
                  >
                    Применить
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- table-responsive временно убрал -->
        <div class="container-stl" v-if="!isExpsLoading">
          <table class="table addButton">
            <thead>
              <tr>
                <th class="text-nowrap">№</th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap">Наименование документа</th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap">Дата загрузки</th>
                <th class="text-nowrap"></th>
                <th class="text-nowrap">ЭЦП</th>
                <th class="text-nowrap">Подписант</th>
                <th class="text-nowrap">Соответствие документа</th>
                <th class="text-nowrap">Дата акцепта</th>
                <th class="text-nowrap">Сотрудник Фонда</th>
                <th class="text-nowrap">Комментарий</th>
                <th class="text-nowrap"></th>
              </tr>
            </thead>
            <tbody v-if="monitoringLizingOrgs.LIST_TYPE">
              <tr
                class="new"
                v-bind:class="{
                  'document-file-delete':
                    monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                    monitoringLizingOrg.FILE_INFO['UF_IS_DELETE'] == 1,
                  'accept-y':
                    monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                    monitoringLizingOrg.FILE_INFO['UF_IS_AKCEPT'] == 1,
                  'accept-n':
                    monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                    monitoringLizingOrg.FILE_INFO['UF_IS_AKCEPT'] == 2
                }"
                unselectable="on"
                style="cursor: default"
                v-for="monitoringLizingOrg in monitoringLizingOrgs.LIST_TYPE"
                v-bind:key="monitoringLizingOrg.ID"
              >
                <!-- Порядковый номер -->
                <td>{{ monitoringLizingOrg.INDEX }}</td>
                <!-- Сноски -->
                <td>
                  <a
                    v-if="monitoringLizingOrg.UF_HELP"
                    class="icon-help-blue2"
                    v-tooltip="{
                      content: monitoringLizingOrg.UF_HELP,
                      classes: 'message'
                    }"
                    target="blank"
                  ></a>
                </td>
                <!-- Шаблон -->
                <td>
                  <a
                    v-if="monitoringLizingOrg.UF_SHABLON"
                    class="icon-shablon-blue2"
                    target="_blank"
                    v-tooltip="{
                      content: monitoringLizingOrg.UF_SHABLON,
                      classes: 'message'
                    }"
                    :href="monitoringLizingOrg.UF_SHABLON"
                  ></a>
                </td>
                <!-- Наименование документа -->
                <td>
                  <a
                    v-if="monitoringLizingOrg.FILE_INFO['UF_FILE']"
                    @click="showDocHistory(monitoringLizingOrg.FILE_INFO.ID)"
                    class="doc-link"
                    style="color: #337ab7"
                    target="_blank"
                    >{{ monitoringLizingOrg.UF_NAME }}</a
                  >
                  <template v-else>{{ monitoringLizingOrg.UF_NAME }}</template>
                </td>
                <td>
                  <i
                    @click="
                      showEditTable = true;
                      editDoc.UF_FILE_USER_NAME =
                        monitoringLizingOrg.FILE_INFO['UF_FILE_USER_NAME'];
                      editDoc.ID = monitoringLizingOrg.FILE_INFO['ID'];
                    "
                    v-if="monitoringLizingOrg.UF_IS_EDIT_TYPE"
                    class="i-edit centerIconFloat"
                    title="Редактировать наименование документа"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="monitoringLizingOrg.UF_IS_DELETE_TYPE"
                    @click="deleteDocument(monitoringLizingOrg.FILE_INFO['ID'])"
                    class="i-delete centerIconFloat"
                    title="Удалить документ"
                  ></i>
                </td>
                <!-- Загрузить - заголовок не выводить -->
                <!-- <td>{{ monitoringLizingOrg.UF_IS_LOAD_FILE }}</td> -->
                <td>
                  <MloUpload
                    v-if="monitoringLizingOrg.UF_IS_LOAD_FILE"
                    :docs="monitoringLizingOrgs.LIST_TYPE"
                    :sub-index="monitoringLizingOrg.ID"
                  ></MloUpload>
                  <div else></div>
                </td>
                <!-- Дата загрузки -->
                <td>
                  {{ monitoringLizingOrg.FILE_INFO["UF_FILE_DATE_LOAD"] }}
                </td>
                <!-- ЭЦП галочка-->
                <td
                  v-if="monitoringLizingOrg.FILE_INFO['UF_FILE']"
                  class="tc-main"
                >
                  <div
                    class="doc-Y"
                    v-if="monitoringLizingOrg.FILE_INFO['UF_IS_SIGN_ECP'] == 1"
                  ></div>
                  <div class="doc-N" v-else></div>
                </td>
                <td v-else></td>

                <!-- ЭЦП Данные -->
                <td style="white-space: nowrap;">
                  <div
                    class="esd-data"
                    v-if="
                      monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                        monitoringLizingOrg.UF_IS_ECP_REQ
                    "
                  >
                    <i
                      class="esd-data esd_icon"
                      @click="
                        getECPInfoFileMonitorLizing(
                          monitoringLizingOrg.FILE_INFO['ID'],
                          monitoringLizingOrg.ID
                        )
                      "
                      style="margin-right: 25px"
                    >
                      ЭЦП
                      <img src="/images/i-eds.png" />
                    </i>
                    <div
                      class="esd-data__info esd-data__info-popup"
                      v-show="resultECP[monitoringLizingOrg.ID]"
                    >
                      <div
                        class="esd-close"
                        @click="closeECP(monitoringLizingOrg.ID)"
                      >
                        <i class="esd_exit"></i>
                      </div>
                      <div v-if="resultECP[monitoringLizingOrg.ID]">
                        <p class="text-center">
                          Подлинник электронного документа, подписанного ЭЦП,
                          <br />хранится в информационной системе “Личный
                          кабинет заемщика” <br />Фонда развития промышленности
                        </p>
                        <h3 class="esd-title">Сведения о сертификате ЭП</h3>
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Сертификат:
                            </div>
                            <div
                              class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn"
                            >
                              {{ result.SERTIFICATE_NUMBER }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Кем выдан:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.ISSUER }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Организация:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.COMPANY }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Кому выдан:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.OWNER_FIO }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Действителен:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.DATE_USE_SERTIFICATE }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Название документа:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.FILE_NAME }}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-4 col-md-4 stl-col-pb-8">
                              Дата загрузки:
                            </div>
                            <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                              {{ result.FILE_DATE_LOAD }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- Подписант -->
                <td>
                  <a
                    v-if="monitoringLizingOrg.FILE_INFO['UF_FILE']"
                    @click="getLinkFileECP(monitoringLizingOrg.FILE_INFO['ID'])"
                    ><img src="/images/methods/doc_ok.png"
                  /></a>

                  {{ monitoringLizingOrg.FILE_INFO["UF_FILE_SIGN_AUTHOR"] }}
                </td>
                <!-- Соответствие документа -->
                <td>
                  <div
                    style="text-align: center"
                    v-if="
                      monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                        monitoringLizingOrg.UF_IS_AKCEPT_FILE
                    "
                  >
                    <label
                      class="radio-inline"
                      style="text-align: right; width: 28px"
                    >
                      <input
                        style="margin-left: -25px;"
                        type="radio"
                        @change="
                          updateFileAccept(
                            monitoringLizingOrg.FILE_INFO['ID'],
                            1
                          )
                        "
                        value="1"
                        :checked="
                          monitoringLizingOrg.FILE_INFO.UF_IS_AKCEPT === 1
                        "
                      />
                      <span>да</span>
                    </label>
                    <label class="radio-inline" style="width: 23px">
                      <input
                        type="radio"
                        style="float: left;display: block;"
                        :id="`ri_${monitoringLizingOrg.FILE_INFO['ID']}`"
                        @change="
                          updateFileAccept(
                            monitoringLizingOrg.FILE_INFO['ID'],
                            2
                          )
                        "
                        value="2"
                        :checked="
                          monitoringLizingOrg.FILE_INFO.UF_IS_AKCEPT === 2
                        "
                      />
                      <span>нет</span>
                    </label>
                  </div>
                  <div v-else style="text-align: center">
                    <div
                      class="doc-Y"
                      v-if="
                        monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                          monitoringLizingOrg.FILE_INFO['UF_IS_AKCEPT'] == 1
                      "
                    ></div>
                    <div
                      class="doc-N"
                      v-else-if="
                        monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                          monitoringLizingOrg.FILE_INFO['UF_IS_AKCEPT'] == 2
                      "
                    ></div>
                  </div>
                </td>
                <!-- Дата акцепта -->
                <td>{{ monitoringLizingOrg.FILE_INFO["UF_DATE_AKCEPT"] }}</td>
                <!-- Сотрудник Фонда -->
                <td>
                  {{ monitoringLizingOrg.FILE_INFO["UF_MANAGER_AKCEPT_NAME"] }}
                </td>
                <!-- Комментарий к документу -->
                <td>
                  <div
                    v-if="monitoringLizingOrg.FILE_INFO['UF_AKCEPT_COMMENT']"
                  >
                    {{ monitoringLizingOrg.FILE_INFO["UF_AKCEPT_COMMENT"] }}
                  </div>
                </td>
                <td>
                  <i
                    class="i-edit centerIcon"
                    v-if="
                      monitoringLizingOrg.FILE_INFO['UF_FILE'] &&
                        monitoringLizingOrg.UF_IS_AKCEPT_COMMENT_FILE
                    "
                    @click="showComment(monitoringLizingOrg)"
                  ></i>
                </td>
              </tr>

              <tr v-if="monitoringLizingOrgs.IS_VIEW_ADD_BUTTON_DOP_DOC == 1">
                <td></td>
                <td></td>
                <td></td>
                <td style="vertical-align: top;">
                  <div v-if="showAddDocForm">
                    <h4 class="h4form">Введите наименование документа:</h4>
                    <input
                      type="text"
                      class="i-main-style tab-wid-550"
                      v-model="reqDoc.UF_FILE_USER_NAME"
                    />
                    <br /><br />
                    <button
                      type="button"
                      class="btn btn-info"
                      style="margin-right: 20px;"
                      @click="addFile(monitoringLizingOrgs.ID_MULTY_TYPE_DOC)"
                    >
                      Добавить документ
                    </button>

                    <button
                      type="button"
                      class="btn btn-close_"
                      @click="showAddDocForm = false"
                    >
                      Отмена
                    </button>
                  </div>
                  <b v-else>
                    <a @click="showAddDocForm = true" class="add-t-r"></a>
                    Добавить документ
                  </b>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h3>Загрузка...</h3>
        </div>

        <div
          class="modal fade in"
          :class="{ show: showDocHistoryDialog }"
          tabindex="-1"
          role="dialog"
        >
          <div class="window-doc modal-fix-h modal-stl" style="width: 1000px;">
            <h3 style="text-transform: uppercase">Загруженные документы</h3>
            <div class="wrap-win-load-history body-fix-h">
              <table style="width: 100%;">
                <tr v-for="e in docHistory">
                  <td
                    :style="{
                      'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                    }"
                  >
                    {{ e.NUMBER }}.
                    <a @click="getOpenFileNewWin(e.UF_FILE)">{{ e.UF_NAME }}</a>
                  </td>
                  <td
                    :style="{
                      'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                    }"
                  >
                    {{ e.USER_LOAD_NAME }}
                  </td>
                  <td
                    :style="{
                      'text-decoration': e.UF_IS_DELETE ? 'line-through' : ''
                    }"
                  >
                    {{ e.UF_FILE_DATE_LOAD }}
                  </td>
                  <td style="width: 130px;">
                    <button
                      v-if="e.UF_IS_DELETE_FILE === 1"
                      @click="deleteFile(e.ID, e)"
                      class="btn-save"
                      type="button"
                    >
                      Удалить
                    </button>
                  </td>
                </tr>
              </table>
            </div>

            <div class="text-center box-btn">
              <button
                class="btn-close"
                type="button"
                @click="showDocHistoryDialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
          <!-- window-doc -->
        </div>
        <!-- modal -->

        <!-- modal comment -->
        <div
          class="modal fade in"
          :class="{ show: showCommentDialog }"
          tabindex="-1"
          role="dialog"
        >
          <div class="window-doc" style="width: 700px; left:30%;">
            <h3 style="margin-bottom: 10px">Введите комментарий</h3>
            <h5 class="cnt-h">
              к документу &laquo;{{ commentActual.FileName }}&raquo;
            </h5>
            <div style="text-align: center; padding-bottom: 10px;">
              <textarea
                class="i-main-style t-dop-style comment-window"
                v-model="commentActual.UF_AKCEPT_COMMENT"
              ></textarea>
            </div>

            <div class="text-center box-btn">
              <button
                class="btn-save btn-save-green"
                style="margin-right: 100px;"
                type="button"
                @click="
                  setCommentManagerAccept(
                    commentActual.ID,
                    commentActual.UF_AKCEPT_COMMENT
                  )
                "
              >
                Сохранить
              </button>

              <button
                class="btn-close"
                type="button"
                @click="showCommentDialog = false"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- wraper -->

    <div
      class="modal fade in"
      v-bind:class="{ show: showEditTable }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showEditTable = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Редактирование документа</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Наименование документа</label>
              <input
                v-model="editDoc.UF_FILE_USER_NAME"
                class="form-control"
                @input="
                  editDoc.UF_FILE_USER_NAME = editDoc.UF_FILE_USER_NAME.replace(
                    /%/g,
                    ''
                  )
                "
              />
            </div>
          </div>
          <div class="modal-footer">
            <button @click="editDocName" type="button" class="btn btn-primary">
              Изменить
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showEditTable = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="footer-sabmit">
          <a
            style="padding: 2px 12px;"
            href="#"
            class="btn btn-default"
            @click="getLinkFileArhive"
            v-show="isGetArhiveLoad ? true : false"
            >Скачать одним архивом</a
          >
        </div>
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  SET_MAIN_MENU,
  FETCH_GROUP_ORGS_LIZING,
  FETCH_MONITORING_LIZING_ORGS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import {
  GroupOrgs,
  MonitoringLizingOrgs,
  ProjectsService
} from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import Multiselect from "vue-multiselect";
import MloUpload from "@/components/monitoring_lizing_orgs/MloUpload";
import Vue from "vue";

export default {
  title: "Мониторинг Лизинговых компаний",
  components: {
    Pagination,
    Datepicker,
    Multiselect,
    MloUpload
  },
  data() {
    return {
      filterForm: {
        UF_TYPE_PERIOD_REPORTING_ID: "",
        UF_YEAR: "",
        UF_COMPANY_ID: ""
      },
      repeats: 1,
      result: "",
      resultECP: {},
      isLoaded: false,
      isGetArhiveLoad: false,
      siteUrl: "",
      extendFilter: false,
      filter: {
        ogrn: "",
        org: "",
        status: ""
      },
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showEditNewProject: false,
      listRendered: false,
      listlizingRendered: false,
      showEditTable: false,
      sp: {
        statuses: []
      },
      ru: ru,
      newProject: {
        UF_NUMBER: "",
        UF_DATE_SOVET: ""
      },
      addError: "",
      orgs: [],
      lizingOrgs: [],
      isEdit: false,
      showDocHistoryDialog: false,
      showCommentDialog: false,
      commentActual: [],
      showAddDocForm: false,
      docHistory: [],
      reqDoc: {
        UF_COMPANY_ID: 0,
        UF_FILE_USER_NAME: "",
        UF_YEAR: "",
        UF_TYPE_PERIOD_REPORTING_ID: 0,
        UF_LIZING_TYPE_DOCUMENTS_ID: 0
      },
      editDoc: {
        ID: 0,
        UF_FILE_USER_NAME: ""
      }
    };
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      this.isEdit = data.IS_REDACT_GROUP_ORG;
      this.isGetArhiveLoad = data.IS_DOWNLOAD_ML_ARCHIVE;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name:
              this.currentUser.TYPE_USER === "manager"
                ? "Реестр проектов"
                : "Мои проекты",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });

          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }*/
      } else {
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }*/
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        /*if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }

        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
    });

    MonitoringLizingOrgs.getListMonitoringLizingOrgs({}).then(({ data }) => {
      this.lizingOrgs = data;
      this.listRendered = true;
      this.listlizingRendered = true;
    }, this);
    this.fetchList();
    console.log("getListOrgsLizing", this.getListOrgsLizing);
  },

  computed: {
    ...mapGetters([
      "groupOrgs",
      "getListOrgsLizing",
      "monitoringLizingOrgs",
      "userProjectProgrammes",
      "addProjectError",
      "isExpsLoading",
      "currentUser",
      "directory",
      "DProgramFinSupport"
    ]),
    listConfig() {
      let filterForm = this.filterForm;
      if (this.$route.query.filter !== undefined) {
        filterForm = JSON.parse(this.$route.query.filter);
      }
      const q = {
        UF_COMPANY_ID: filterForm.UF_COMPANY_ID
          ? filterForm.UF_COMPANY_ID.ID
          : "",
        UF_YEAR: filterForm.UF_YEAR ? filterForm.UF_YEAR.YEAR : "",
        UF_TYPE_PERIOD_REPORTING_ID: filterForm.UF_TYPE_PERIOD_REPORTING_ID
          ? filterForm.UF_TYPE_PERIOD_REPORTING_ID.ID
          : ""
      };
      return q;
    },
    filterKvartal() {
      if (
        typeof this.filterForm.UF_YEAR === "object" &&
        this.filterForm.UF_YEAR.YEAR > 0
      ) {
        if (
          this.filterForm.UF_YEAR.YEAR != this.monitoringLizingOrgs.DEFAULT_YEAR
        ) {
          this.kvartalClear();
        }
        return this.filterForm.UF_YEAR.PERIOD_LIST;
      }
      return [];
    }
  },

  methods: {
    updateFileAccept(id, accept) {
      MonitoringLizingOrgs.saveAcceptDocumentMonitorLizing(id, {
        UF_IS_AKCEPT: accept
      }).then(({ data }) => {
        if (data.error) {
          document.getElementById("ri_" + id).checked = false;
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 6000
            });
          }, this);
        }
        this.fetchList();
      }, this);
    },
    closeECP(id) {
      this.resultECP[id] = !this.resultECP[id];
    },
    getECPInfoFileMonitorLizing(id, id2) {
      Vue.set(this.resultECP, [id2], true);

      MonitoringLizingOrgs.getECPInfoFileMonitorLizing(id).then(({ data }) => {
        this.result = data.result;
        this.resultECP[id2] = true;
      });
    },
    getLinkFileECP(id) {
      MonitoringLizingOrgs.getLinkFileECP(id).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    getOpenFileNewWin(url) {
      window.open(AUTH_URL.replace(new RegExp("[\\/]+$"), "") + url, "_blank");
    },
    kvartalClear() {
      this.filterForm.UF_TYPE_PERIOD_REPORTING_ID = "";
    },
    getPTypeId(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t && t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    clearFilter() {
      this.filterForm = {
        UF_TYPE_PERIOD_REPORTING_ID: "",
        UF_YEAR: "",
        UF_COMPANY_ID: ""
      };
      this.fetchList();
    },
    applyFilter() {
      this.$router.push({
        path: "/monitoring_lizing_orgs",
        query: { filter: JSON.stringify(this.filterForm) }
      });
      this.fetchList();
    },
    fetchList() {
      this.$store.dispatch(FETCH_GROUP_ORGS_LIZING);
      this.$store
        .dispatch(FETCH_MONITORING_LIZING_ORGS_LIST, this.listConfig)
        .then(() => {
          let defYear = this.monitoringLizingOrgs.DEFAULT_YEAR;
          let yearDefTemp = this.monitoringLizingOrgs.PHILTER_LIST.filter(
            function(yearArr) {
              return yearArr.YEAR == defYear;
            }
          );
          this.filterForm.UF_YEAR = yearDefTemp[0];

          let defPeriod = this.monitoringLizingOrgs.DEFAULT_PERIOD_ID;
          let periodDefTemp = this.filterForm.UF_YEAR.PERIOD_LIST.filter(
            function(periodArr) {
              return periodArr.ID == defPeriod;
            }
          );
          this.filterForm.UF_TYPE_PERIOD_REPORTING_ID = periodDefTemp[0];
          console.log(this.filterForm.UF_TYPE_PERIOD_REPORTING_ID);

          this.filterForm.UF_COMPANY_ID = this.monitoringLizingOrgs.DEFAULT_ORG_INFO;

          this.isLoaded = true;
        });
    },
    getItem(item) {
      GroupOrgs.getRecordOrgGroup(item.COMPANY.UF_COMPANY_ID)
        .then(({ data }) => {
          this.newProject = data;
          this.newProject.ID = item.COMPANY.UF_COMPANY_ID;
          this.showEditNewProject = true;
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onEditProject() {
      if (!this.newProject.IS_ADD_IN_GROUP) {
        this.newProject.UF_GRP_CMP_ID = 0;
        this.newProject.UF_COMMENT = "";
      }
      GroupOrgs.editRecordOrgGroup(this.newProject.ID, this.newProject)
        .then(() => {
          this.fetchList();
          this.showEditNewProject = false;
          this.newProject = {};
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    filterItemText(count) {
      return `и еще ${count}`;
    },
    getLinkFileArhive() {
      MonitoringLizingOrgs.getLinkFileArhive(this.listConfig).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    showDocHistory(id) {
      this.docHistory = [];
      MonitoringLizingOrgs.getDocumenetHistory(id).then(({ data }) => {
        this.showDocHistoryDialog = true;
        this.docHistory = data.FILE_LIST;
      }, this);
    },
    deleteFile(id, e) {
      MonitoringLizingOrgs.deleteFile(id, e.IS_ACTUAL_VERSION).then(
        ({ data }) => {
          if (data.error === false) {
            if (e.IS_ACTUAL_VERSION == 1) {
              this.showDocHistory(id);
              this.fetchList();
            } else {
              this.showDocHistory(e.UF_PARENT_DOCUMENT_ID);
            }
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        },
        this
      );
    },
    addFile(typeId) {
      this.reqDoc.UF_LIZING_TYPE_DOCUMENTS_ID = typeId;
      this.reqDoc.UF_COMPANY_ID = this.monitoringLizingOrgs.DEFAULT_ORG_ID;
      this.reqDoc.UF_YEAR = this.monitoringLizingOrgs.DEFAULT_YEAR;
      this.reqDoc.UF_TYPE_PERIOD_REPORTING_ID = this.monitoringLizingOrgs.DEFAULT_PERIOD_ID;
      MonitoringLizingOrgs.addRequestDocument(this.reqDoc).then(response => {
        if (!response.data.error) {
          this.showAddDocForm = false;
          this.fetchList();
          this.reqDoc.UF_FILE_USER_NAME = "";
          this.$toasted.show("Документ успешно добавлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
    },
    deleteDocument(id) {
      if (confirm("Вы действительно хотите удалить документ?")) {
        MonitoringLizingOrgs.deleteRequestFile(id).then(({ data }) => {
          if (data.error === false) {
            this.fetchList();
            this.$toasted.show("Документ успешно удален", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
        }, this);
      }
    },
    editDocName() {
      MonitoringLizingOrgs.editRequestDocument(
        this.editDoc.ID,
        this.editDoc
      ).then(response => {
        if (!response.data.error) {
          this.showEditTable = false;
          this.fetchList();
          this.editDoc.UF_FILE_USER_NAME = "";
          this.$toasted.show("Документ успешно изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          response.data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      }, this);
      console.log(this.editDoc);
    },
    showComment(monitoringLizingOrg) {
      this.commentActual = [];
      this.commentActual.ID = monitoringLizingOrg.FILE_INFO.ID;
      this.commentActual.UF_AKCEPT_COMMENT =
        monitoringLizingOrg.FILE_INFO.UF_AKCEPT_COMMENT;
      this.showCommentDialog = true;
      this.commentActual.FileName = monitoringLizingOrg.UF_NAME;
    },
    setCommentManagerAccept(idFile, comment) {
      MonitoringLizingOrgs.setCommentManagerAccept(idFile, {
        UF_AKCEPT_COMMENT: comment
      }).then(({ data }) => {
        if (!data.error) {
          this.showCommentDialog = false;
          this.fetchList();
          this.commentActual.UF_AKCEPT_COMMENT = "";
          //this.updateDocInfo();
        } else {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
      });
    }
  }
};
</script>
